import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=73879d94&"
import script from "./FeatureBox.js?vue&type=script&lang=js&"
export * from "./FeatureBox.js?vue&type=script&lang=js&"
import style0 from "./FeatureBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports